// extracted by mini-css-extract-plugin
module.exports = {"pathFill":"LoadingSpinner_pathFill__eKOuN","dash":"LoadingSpinner_dash__T6y0e"};